/** @jsx jsx */
import { jsx, css } from '@emotion/core';

import { N30A } from '@atlaskit/theme/colors';
import FeedbackModal from './feedback-modal';
import { token } from '@atlaskit/tokens';

import { gridSize as getGridSize } from '@atlaskit/theme/constants';

const gridSize = getGridSize();

const dividerStyles = css({
  border: 0,
  borderBottom: `2px solid ${token('color.border', N30A)}`,
  margin: `${gridSize}px 0`,
});

const itemWrapperStyles = css({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'row',
  gap: '15px',
  marginTop: '14px',
  marginBottom: '5px',
});

const mainWrapperStyles = css({
  display: 'flex',
  flexDirection: 'column',
});

interface FeedbackSectionProps {
  pageUrl: string;
  subpageTabName: string;
  tabName: string;
  title: string;
}

const FeedbackSection = ({
  pageUrl,
  subpageTabName,
  tabName,
  title,
}: FeedbackSectionProps) => {
  return (
    <div css={mainWrapperStyles}>
      <hr css={dividerStyles} />
      <div css={itemWrapperStyles}>
        <div>
          <p>
            <b>Was this page helpful?</b>
          </p>
        </div>
        <FeedbackModal
          pageUrl={pageUrl}
          subpageTabName={subpageTabName}
          tabName={tabName}
          title={title}
        />
      </div>
      <div>
        <p>We use this feedback to improve our documentation.</p>
      </div>
    </div>
  );
};

export default FeedbackSection;
